<template>
  <div class="skuRefund">
    <el-card>
      <el-radio-group v-if="isShow" v-model="filter.belongCompanyId" size="small" @change="reset">
        <el-radio-button label="">集团数据</el-radio-button>
        <el-radio-button v-for="item in companyList" :key="item.id" :label="item.id">{{item.name}}</el-radio-button>
        <el-radio-button :label="100">中英考研</el-radio-button>
        <el-radio-button :label="400">神啦考研</el-radio-button>
      </el-radio-group>
      <div style="margin-top: 10px">
        <el-radio-group v-model="filter.type" size="small" @change="initPage">
          <el-radio-button :label="1">全部数据</el-radio-button>
          <el-radio-button :label="2">当月数据</el-radio-button>
        </el-radio-group>
        <el-select size="small" v-if="filter.type === 2" @change="initPage" style="margin-left: 20px" v-model="filter.dateType">
          <el-option :value="1" label="本月支付订单"></el-option>
          <el-option :value="2" label="本月申请退费"></el-option>
          <el-option :value="3" label="本月完成退费"></el-option>
        </el-select>
        <el-tooltip style="margin-left: 20px" v-if="filter.type === 2" class="item" effect="dark" :content="filter.dateType === 1 ? '本月1号至当前日期已支付订单退费数据' : filter.dateType === 2 ? '本月1号至当前日期已申请退费工单数据' : '本月1号至当前日期已完成退费工单数据'" placement="bottom">
          <span class="el-icon-question" style="font-size: 20px;"></span>
        </el-tooltip>
        <span class="label">产品状态</span>
        <el-select size="small" v-model="filter.shelfFlag">
          <el-option value="" label="全部"></el-option>
          <el-option :value="1" label="已下架"></el-option>
          <el-option :value="2" label="已上架"></el-option>
        </el-select>
        <span class="label">产品名称</span>
        <el-input size="small" v-model="filter.spuName" style="width: 200px" placeholder="请输入产品名称"></el-input>
        <el-button size="small" type="primary" style="margin: 0 10px 0 20px" @click="initPage">查询</el-button>
        <el-button size="small" @click="reset">重置</el-button>
      </div>
      <el-table style="margin-top: 20px" :data="list" border>
        <el-table-column align="center" label="产品名称" min-width="200" fixed prop="spuName"></el-table-column>
        <el-table-column align="center" v-if="!filter.belongCompanyId" label="产品创建平台" width="120" key="100" prop="platform">
          <template slot-scope="scope">
            <span v-if="scope.row.platform === 1">千帆</span>
            <span v-else-if="scope.row.platform === 100">中英考研</span>
            <span v-else-if="scope.row.platform === 400">神啦考研</span>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="产品状态" prop="shelfFlag">
          <template slot-scope="scope">
            {{ scope.row.shelfFlag === 1 ? '下架' : '上架' }}
          </template>
        </el-table-column>
        <template v-if="filter.type === 1 || (filter.type === 2 && filter.dateType === 1)">
          <el-table-column align="center" label="已支付订单金额" prop="payAmt" width="150" key="1">
            <template slot="header">
              已支付订单金额
              <el-tooltip class="item" effect="dark" content="该产品已成功支付的所有订单总金额" placement="bottom">
                <span class="el-icon-question"></span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column align="center" label="已退费金额占比" prop="refundRate" width="150" key="2">
            <template slot="header">
              已退费金额占比
              <el-tooltip class="item" effect="dark" content="该产品已退费总金额/已支付订单金额" placement="bottom">
                <span class="el-icon-question"></span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span v-if="scope.row.refundRate">{{ scope.row.refundRate + '%' }}</span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="申请退费工单数" prop="applyNum" width="150" key="3">
            <template slot="header">
              申请退费工单数
              <el-tooltip class="item" effect="dark" content="该产品已成功支付的所有订单，申请退费工单数量" placement="bottom">
                <span class="el-icon-question"></span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column align="center" label="申请退费金额" prop="applyAmt" width="150" key="4">
            <template slot="header">
              申请退费金额
              <el-tooltip class="item" effect="dark" content="该产品已成功支付的所有订单，申请退费的退费总金额" placement="bottom">
                <span class="el-icon-question"></span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column align="center" label="已退费工单数" prop="refundNum" width="150" key="5">
            <template slot="header">
              已退费工单数
              <el-tooltip class="item" effect="dark" content="该产品已成功支付的所有订单，完成了退费工单数量" placement="bottom">
                <span class="el-icon-question"></span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column align="center" label="已退费金额" prop="refundAmt" width="150" key="6">
            <template slot="header">
              已退费金额
              <el-tooltip class="item" effect="dark" content="该产品已成功支付的所有订单，已完成退费的退费总金额" placement="bottom">
                <span class="el-icon-question"></span>
              </el-tooltip>
            </template>
          </el-table-column>
        </template>
        <template v-if="filter.type === 2 && filter.dateType === 2">
          <el-table-column align="center" label="申请退费订单金额" prop="payAmt" width="160" key="7">
            <template slot="header">
              申请退费订单金额
              <el-tooltip class="item" effect="dark" content="该产品申请退费工单关联订单支付总金额" placement="bottom">
                <span class="el-icon-question"></span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column align="center" label="申请退费工单数" prop="applyNum" width="150" key="8">
            <template slot="header">
              申请退费工单数
              <el-tooltip class="item" effect="dark" content="该产品已申请退费的工单数量" placement="bottom">
                <span class="el-icon-question"></span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column align="center" label="申请退费工单金额" prop="applyAmt" width="170" key="9">
            <template slot="header">
              申请退费工单金额
              <el-tooltip class="item" effect="dark" content="该产品已申请退费的退费总金额" placement="bottom">
                <span class="el-icon-question"></span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column align="center" label="已退费工单数" prop="refundNum" width="150" key="10">
            <template slot="header">
              已退费工单数
              <el-tooltip class="item" effect="dark" content="该产品已申请退费的工单中，已完成退费的工单数量" placement="bottom">
                <span class="el-icon-question"></span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column align="center" label="已退费工单占比" prop="refundNumRate" width="150" key="111">
            <template slot="header">
              已退费工单占比
              <el-tooltip class="item" effect="dark" content="该产品已退费工单数量/申请退费工单数量" placement="bottom">
                <span class="el-icon-question"></span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span v-if="scope.row.refundNumRate || scope.row.refundNumRate === 0">{{ scope.row.refundNumRate + '%' }}</span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="已退费金额" prop="refundAmt" width="150" key="12">
            <template slot="header">
              已退费金额
              <el-tooltip class="item" effect="dark" content="该产品已申请退费的订单中，已完成退费的退费总金额" placement="bottom">
                <span class="el-icon-question"></span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column align="center" label="已退费金额占比" prop="refundRate" width="150" key="13">
            <template slot="header">
              已退费金额占比
              <el-tooltip class="item" effect="dark" content="该产品已退费金额/申请退费金额" placement="bottom">
                <span class="el-icon-question"></span>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <span v-if="scope.row.refundRate || scope.row.refundRate === 0">{{ scope.row.refundRate + '%' }}</span>
              <span v-else></span>
            </template>
          </el-table-column>
        </template>
        <template v-if="filter.type === 2 && filter.dateType === 3">
          <el-table-column align="center" label="已退费工单数" prop="refundNum" width="150" key="14">
            <template slot="header">
              已退费工单数
              <el-tooltip class="item" effect="dark" content="该产品已完成退费的工单数量" placement="bottom">
                <span class="el-icon-question"></span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column align="center" label="已退费金额" prop="refundAmt" width="150" key="15">
            <template slot="header">
              已退费金额
              <el-tooltip class="item" effect="dark" content="该产品已完成退费的退费总金额" placement="bottom">
                <span class="el-icon-question"></span>
              </el-tooltip>
            </template>
          </el-table-column>
        </template>
        <el-table-column align="center" label="操作" prop="">
          <template slot-scope="scope">
            <a href="javascript:;" @click="lookDetails(scope.row)">查看详情</a>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="text-align: center; margin-top: 10px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="filter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>

    <el-dialog
      :title="name + '产品退费数据'"
      :visible.sync="dialogVisible"
      width="1000px"
      :before-close="handleClose">
      <span class="label">班级状态</span>
      <el-select size="small" v-model="filterSku.publishFlag">
        <el-option value="" label="全部"></el-option>
        <el-option :value="2" label="已发布"></el-option>
        <el-option :value="1" label="未发布"></el-option>
      </el-select>
      <span class="label">班级名称</span>
      <el-input size="small" style="width: 200px" placeholder="请输入班级名称" v-model="filterSku.skuName"></el-input>
      <el-button size="small" type="primary" style="margin: 0 10px 0 20px" @click="initSkuPage">查询</el-button>
      <el-button size="small" @click="resetSku">重置</el-button>
      <el-table :data="listSku" style="margin-top: 10px" border>
        <el-table-column align="center" label="班级名称" width="150" fixed prop="skuName"></el-table-column>
        <el-table-column align="center" label="班级状态" prop="publishFlag">
          <template slot-scope="scope">
            {{ scope.row.publishFlag === 1 ? '未发布' : '已发布' }}
          </template>
        </el-table-column>
        <template v-if="filter.type === 1 || (filter.type === 2 && filter.dateType === 1)">
          <el-table-column align="center" label="已支付订单金额" prop="payAmt"  key="1"></el-table-column>
          <el-table-column align="center" label="已退费金额占比" prop="refundRate"  key="2">
            <template slot-scope="scope">
              <span v-if="scope.row.refundRate || scope.row.refundRate === 0">{{ scope.row.refundRate + '%' }}</span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="申请退费工单数" prop="applyNum"  key="3"></el-table-column>
          <el-table-column align="center" label="申请退费金额" prop="applyAmt"  key="4"></el-table-column>
          <el-table-column align="center" label="已退费工单数" prop="refundNum"  key="5"></el-table-column>
          <el-table-column align="center" label="已退费金额" prop="refundAmt"  key="6"></el-table-column>
        </template>
        <template v-if="filter.type === 2 && filter.dateType === 2">
          <el-table-column align="center" label="申请退费订单金额" prop="payAmt"  key="7"></el-table-column>
          <el-table-column align="center" label="申请退费工单数" prop="applyNum"  key="8"></el-table-column>
          <el-table-column align="center" label="申请退费工单金额" prop="applyAmt"  key="9"></el-table-column>
          <el-table-column align="center" label="已退费工单数" prop="refundNum"  key="10"></el-table-column>
          <el-table-column align="center" label="已退费工单占比" prop="refundNumRate"  key="110">
            <template slot-scope="scope">
              <span v-if="scope.row.refundNumRate">{{ scope.row.refundNumRate + '%' }}</span>
              <span v-else></span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="已退费金额" prop="refundAmt"  key="12"></el-table-column>
          <el-table-column align="center" label="已退费金额占比" prop="refundRate"  key="13">
            <template slot-scope="scope">
              <span v-if="scope.row.refundRate">{{ scope.row.refundRate + '%' }}</span>
              <span v-else></span>
            </template>
          </el-table-column>
        </template>
        <template v-if="filter.type === 2 && filter.dateType === 3">
          <el-table-column align="center" label="已完成退费工单数" prop="refundNum" width="150" key="14"></el-table-column>
          <el-table-column align="center" label="已退费金额" prop="refundAmt" width="150" key="15"></el-table-column>
        </template>
      </el-table>

      <el-pagination
        style="text-align: center; margin-top: 10px"
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :current-page="filterSku.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filterSku.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalSku">
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import { getAvailableCompanyList, getAllSpuRefund, getSingleSpuRefund, getAllSkuRefund, getSingleSkuRefund } from '@/api/refund'
export default {
  name: 'SkuRefund',
  data () {
    return {
      filter: {
        belongCompanyId: '',
        type: 1,
        dateType: 1,
        shelfFlag: '',
        spuName: '',
        page: 1,
        limit: 10
      },
      filterSku: {
        publishFlag: '',
        skuName: '',
        spuId: '',
        page: 1,
        limit: 10
      },
      total: 0,
      list: [],
      companyList: [],
      name: '',
      dialogVisible: false,
      totalSku: 0,
      listSku: [],
      isShow: true
    }
  },
  created() {
    if (this.$myStore.state.user.userInfo.companyId !== '1') {
      this.filter.belongCompanyId = this.$myStore.state.user.userInfo.companyId
      this.isShow = false
    }
    this.getAvailableCompanyList()
    this.init()
  },
  methods: {
    async getAvailableCompanyList () {
      const res = await getAvailableCompanyList()
      this.companyList = res.data
    },
    reset() {
      this.filter = {
        belongCompanyId: this.filter.belongCompanyId,
        type: 1,
        dateType: 1,
        shelfFlag: '',
        spuName: '',
        page: 1,
        limit: 10
      }
      this.init()
    },
    initPage() {
      this.filter.page = 1
      this.init()
    },
    async init () {
      let res
      const sendObj = {...this.filter}
      if (sendObj.type === 1) {
        sendObj.dateType = 1
      }
      if (sendObj.belongCompanyId) {
        // 租户
        res = await getSingleSpuRefund(sendObj)
      } else {
        // 集团
        res = await getAllSpuRefund(sendObj)
      }
      this.total = +res.data.total
      this.list = res.data.records
    },
    initSkuPage() {
      this.filterSku.page = 1
      this.initSku()
    },
    async initSku () {
      let res
      const sendObj = {
        belongCompanyId: this.filter.belongCompanyId,
        type: this.filter.type,
        dateType: this.filter.dateType,
        ...this.filterSku
      }
      if (sendObj.type === 1) {
        sendObj.dateType = 1
      }
      if (this.filter.belongCompanyId) {
        // 租户
        res = await getAllSkuRefund(sendObj)
      } else {
        // 集团
        res = await getAllSkuRefund(sendObj)
      }
      this.totalSku = +res.data.total
      this.listSku = res.data.records
    },
    lookDetails(row) {
      this.filterSku.spuId = row.spuId
      this.name = row.spuName
      this.initSku()
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
      this.filterSku = {
        publishFlag: '',
        skuName: '',
        spuId: '',
        page: 1,
        limit: 10
      }
      this.name = ''
      this.listSku = []
      this.totalSku = 0
    },
    resetSku() {
      this.filterSku = {
        publishFlag: '',
        skuName: '',
        spuId: this.filterSku.spuId,
        page: 1,
        limit: 10
      }
      this.initSku()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.init()
    },
    handleSizeChange(v) {
      this.filter.limit = v
      this.filter.page = 1
      this.init()
    },
    handleCurrentChange1(v) {
      this.filterSku.page = v
      this.initSku()
    },
    handleSizeChange1(v) {
      this.filterSku.limit = v
      this.filterSku.page = 1
      this.initSku()
    }
  }
}
</script>

<style lang="scss" scoped>
.skuRefund {
  span.label {
    display: inline-block;
    width: 100px;
    text-align: right;
    margin-right: 10px;
  }
}
</style>
